import React from "react"
import { TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import FakeVideosContent from "@assets/images/FakeVideosContent"

const IvehteMissions = () => {
    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.title} fontSize={RFValue(24)}>
                    Les missions d’IVEHTE{" "}
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={RFValue(16)}>
                    Découvrez en vidéo les missions d’IVEHTE !{" "}
                </OpenSansText>
            </View>

            <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                IVEHTE a pour objectif de vous accompagner dans la prise en charge de votre maladie cardiovasculaire.
            </OpenSansText>

            <View style={styles.content}>
                <BreeSerifText style={styles.missionLabel} fontSize={RFValue(20)}>
                    Les missions d’IVEHTE{" "}
                </BreeSerifText>
                <TouchableOpacity activeOpacity={0.6} style={styles.videoContainer}>
                    <FakeVideosContent style={{ backgroundColor: baseColors.green.pastel }} />
                </TouchableOpacity>
            </View>
        </CustomScrollableContentWithBackHeader>
    )
}

export default IvehteMissions
